import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
export default function RepresentativeNotifications({ api, revision, onOpen, busy }) {
 const [data, setData] = useState(null);
 const [expanded, setExpanded] = useState(false);
 const [page, setPage] = useState(1);
 const [error, setError] = useState('');
 const [retry, setRetry] = useState(0);
 useEffect(() => {
  let live = true, timer;
  setData(null);
  const load = async () => {
   try {
    const r = await api.get('/api/representante-portal/avisos', { params: { page } });
    if (live) {
     if (page > (r.data.last_page || 1)) setPage(r.data.last_page || 1);
     else setData(r.data);
     setError('');
    }
   } catch { if (live) setError('Não foi possível atualizar os avisos.'); }
   finally { if (live) timer = setTimeout(load, 30000); }
  };
  load();
  return () => { live = false; clearTimeout(timer); };
 }, [api, revision, page, retry]);
 return <aside className="rep-notifications" aria-label="Avisos de leads">
  <div className="d-flex flex-wrap justify-content-between align-items-center gap-2">
   <div aria-live="polite"><strong>{data ? `${data.total || 0} leads ainda não vistos` : 'Avisos de leads'}</strong><p className="small text-muted mb-0">Atendimentos atribuídos a você. Atualização a cada 30 segundos.</p></div>
   <Button variant="outline-success" aria-expanded={expanded} aria-controls="rep-notification-list" onClick={() => setExpanded(v => !v)}>{expanded ? 'Ocultar avisos' : 'Ver avisos'}</Button>
  </div>
  {error && <Alert variant="warning" className="mt-3 mb-0">{error} <Button variant="link" onClick={() => setRetry(v => v + 1)}>Tentar novamente</Button></Alert>}
  {expanded && <div id="rep-notification-list" className="mt-3">
   {!data ? <p>Carregando avisos…</p> : <>
    {!data.data?.length && <p className="mb-0">Nenhum lead pendente de visualização.</p>}
    {data.data?.map(lead => <div key={lead.id} className="d-flex flex-wrap justify-content-between align-items-center gap-2 border-top py-3"><div><strong>{lead.nome}</strong><div className="small text-muted">{lead.telefone}</div></div><Button variant="success" disabled={busy} onClick={() => onOpen(lead.id)}>Abrir atendimento</Button></div>)}
    {data.last_page > 1 && <div className="rep-pagination"><Button variant="light" disabled={page <= 1} onClick={() => setPage(v => v - 1)}>Anterior</Button><span>{page} / {data.last_page}</span><Button variant="light" disabled={page >= data.last_page} onClick={() => setPage(v => v + 1)}>Próxima</Button></div>}
   </>}
  </div>}
 </aside>;
}
